import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createSupplierGroup } from '../../../common/api/clients/supplierGroups.api';
import { queries } from '../../../common/api/queryKeys/queries';

export const useSupplierGroupCreate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createSupplierGroup,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: queries.supplierGroups._def }),
    });
};
